export var EditorState;
(function (EditorState) {
  EditorState[EditorState["ExecutingCode"] = 1] = "ExecutingCode";
  EditorState[EditorState["Idle"] = 2] = "Idle";
  EditorState[EditorState["Initializing"] = 4] = "Initializing";
  EditorState[EditorState["RunAborted"] = 8] = "RunAborted";
  EditorState[EditorState["ShowHelp"] = 16] = "ShowHelp";
  EditorState[EditorState["ShowPassedFeedbackForm"] = 32] = "ShowPassedFeedbackForm";
  EditorState[EditorState["ShowProblems"] = 64] = "ShowProblems";
  EditorState[EditorState["ShowSubmissionResults"] = 128] = "ShowSubmissionResults";
  EditorState[EditorState["ShowTestResults"] = 256] = "ShowTestResults";
  EditorState[EditorState["Submitting"] = 512] = "Submitting";
  EditorState[EditorState["Testing"] = 1024] = "Testing";
  EditorState[EditorState["WaitingInput"] = 2048] = "WaitingInput";
  EditorState[EditorState["WorkerInitializing"] = 4096] = "WorkerInitializing";
  EditorState[EditorState["WorkerActive"] = 7169] = "WorkerActive";
})(EditorState || (EditorState = {}));